<template>
  <filter-wrapper v-model="form.search" @submit="submit" />
</template>

<script>
  import FilterWrapper from '@shared/components/filter-search';
  import { mapActions } from 'vuex';

  export default {
    components: {
      FilterWrapper
    },
    data: () => ({
      form: {
        search: ''
      }
    }),
    methods: {
      ...mapActions('pbx/worksheets/table', ['search']),

      submit: function() {
        const { search = '' } = this.form;

        const params = {
          name: search
        };

        this.search(params);
      }
    }
  };
</script>
